module.exports = __webpack_public_path__ + "static/media/5d_website_logo_diamond_aws.c38bb827.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/5d_website_logo_diamond_aws.jpg
// module id = 88
// module chunks = 0